import { render, staticRenderFns } from "./discountReceived.vue?vue&type=template&id=6435716b&scoped=true&"
import script from "./discountReceived.vue?vue&type=script&lang=js&"
export * from "./discountReceived.vue?vue&type=script&lang=js&"
import style0 from "./discountReceived.vue?vue&type=style&index=0&id=6435716b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435716b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
